// removed by extract-text-webpack-plugin
module.exports = {"business-logo":"app-components-receipt-commons-BrandImage-__BrandImage___3DcI0","receipt-business-info-box":"app-components-receipt-commons-BrandImage-__BrandImage___2EnyV","receipt-brand-img":"app-components-receipt-commons-BrandImage-__BrandImage____EqE1","receipt-business-name":"app-components-receipt-commons-BrandImage-__BrandImage___2DTxx","receipt-business-phone":"app-components-receipt-commons-BrandImage-__BrandImage___1CMPx"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/commons/BrandImage/BrandImage.css
// module id = 1996
// module chunks = 0